var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.6C17.76 1.6 22.4 6.24 22.4 12C22.4 17.76 17.76 22.4 12 22.4C6.24 22.4 1.6 17.76 1.6 12C1.6 6.24 6.24 1.6 12 1.6ZM12 0C5.36 0 0 5.36 0 12C0 18.64 5.36 24 12 24C18.64 24 24 18.64 24 12C24 5.36 18.64 0 12 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6787 7.76125C17.3587 7.44125 16.9587 7.28125 16.5587 7.28125C16.0787 7.28125 15.6787 7.44125 15.3587 7.76125L10.3987 13.2012L8.63875 11.2012C8.31875 10.8812 7.91875 10.6412 7.43875 10.6412C7.03875 10.6412 6.63875 10.8012 6.31875 11.0412C5.67875 11.6813 5.59875 12.6413 6.23875 13.3613L9.19875 16.6412C9.43875 16.8812 9.67875 17.0412 9.99874 17.1212C10.1587 17.1212 10.2387 17.1212 10.3987 17.1212C10.8787 17.1212 11.2787 16.9612 11.5987 16.6412L17.7587 9.92125C18.3187 9.36125 18.3187 8.32125 17.6787 7.76125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceCheck);
export default __webpack_public_path__ + "static/media/device-check.015b18a0d0675d7530580116679f737c.svg";
export { ForwardRef as ReactComponent };